const integer = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 })
const oneDecimal = new Intl.NumberFormat('en-US', { maximumFractionDigits: 1 })

export function formatRate(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '–'
  return `${integer.format(value * 100)}%`
}

export function formatCount(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '–'
  return integer.format(value)
}

export function formatDecimal(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '–'
  return oneDecimal.format(value)
}

export function formatSignedDelta(value: number | null | undefined, suffix = 'pp'): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '–'
  const sign = value > 0 ? '+' : ''
  return `${sign}${integer.format(value)}${suffix}`
}

const rangeDay = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short' })

/** Human date range for card headers. Raw ISO instants on screen forced a 481px
 *  min-content at 375px viewports — and read as debug output besides. */
export function formatRangeLabel(fromIso: string, toIso: string): string {
  const from = new Date(fromIso)
  const to = new Date(toIso)
  if (Number.isNaN(from.getTime()) || Number.isNaN(to.getTime())) return '–'
  return `${rangeDay.format(from)} – ${rangeDay.format(to)}`
}
